<template>
  <div class="page-wrapper">
    <div class="page-container">
      <!-- Breadcrumb -->
      <!-- Breadcrumb & Actions -->
      <div class="page-header">
        <div class="breadcrumb">
          <span class="crumb-link" @click="$router.push('/')">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
            Asosiy
          </span>
          <span class="separator">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </span>
          <span class="crumb-link" @click="$router.push('/tanlov-fanlar')">Tanlov fanlar</span>
          <span class="separator">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </span>
          <span class="crumb-current">{{ departmentName }} o'qituvchilari</span>
        </div>

        <button class="btn-sync" :disabled="syncing" @click="syncEmployees">
          <svg v-if="syncing" class="spinner-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-opacity="0.25"></circle>
            <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-linecap="round"></path>
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67"/>
          </svg>
          <span>{{ syncing ? "HEMIS dan yangilanmoqda..." : "Xodimlarni yangilash (HEMIS)" }}</span>
        </button>
      </div>

      <!-- Stats Bar -->
      <div class="stats-bar">
        <div class="stat-card">
          <div class="stat-icon teachers-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
          </div>
          <div class="stat-info">
            <span class="stat-value">{{ teachersList.length }}</span>
            <span class="stat-label">Jami o'qituvchilar</span>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon dept-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
          </div>
          <div class="stat-info">
            <span class="stat-value dept-name-stat">{{ departmentName }}</span>
            <span class="stat-label">Kafedra nomi</span>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon status-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
          </div>
          <div class="stat-info">
            <span class="stat-value">Faol</span>
            <span class="stat-label">Holat filtri</span>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="table-card">
        <!-- Loading -->
        <div v-if="loading" class="loading-container">
          <div class="spinner"></div>
          <span class="loading-text">Ma'lumotlar yuklanmoqda...</span>
        </div>

        <!-- Empty -->
        <div v-else-if="teachersList.length === 0" class="empty-container">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><line x1="23" y1="11" x2="17" y2="11"></line></svg>
          <p>O'qituvchilar topilmadi</p>
        </div>

        <!-- Table Content -->
        <table v-else class="main-table">
          <thead>
            <tr>
              <th class="col-num">#</th>
              <th class="col-img">Rasm</th>
              <th class="col-name">F.I.Sh</th>
              <th class="col-position">Lavozimi</th>
              <th class="col-degree">Ilmiy daraja</th>
              <th class="col-rank">Ilmiy unvon</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(teacher, idx) in teachersList" :key="teacher.id || idx" class="data-row" @click="goToScientificActivity(teacher)" style="cursor: pointer;">
              <td class="cell-num">{{ idx + 1 }}</td>
              <td class="cell-img">
                <div class="avatar-wrapper" v-if="getTeacherImage(teacher)">
                  <img :src="getTeacherImage(teacher)" alt="Rasm" class="teacher-img" @error="handleImgError($event, teacher)" />
                </div>
                <div class="avatar-placeholder" v-else>
                  <span>{{ getInitials(teacher) }}</span>
                </div>
              </td>
              <td class="cell-name">{{ teacher.short_name || teacher.full_name }}</td>
              <td class="cell-position">
                <span class="position-badge" :class="getPositionClass(teacher)">
                  {{ teacher.staffPosition ? teacher.staffPosition.name : '—' }}
                </span>
              </td>
              <td class="cell-degree">
                <span v-if="teacher.academicDegree" class="degree-text">{{ teacher.academicDegree.name }}</span>
                <span v-else class="no-data">Darajasiz</span>
              </td>
              <td class="cell-rank">
                <span v-if="teacher.academicRank" class="rank-badge">{{ teacher.academicRank.name }}</span>
                <span v-else class="no-data">Unvonsiz</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="bottom-bar">
      <span>Dastur versiyasi 1.0.5 / Yadro 2.0.1 / Sana 04.04.2025 10:29:29</span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
const API = process.env.VUE_APP_API_URL;

export default {
  name: "KafedraOqituvchilari",
  data() {
    return {
      departmentId: "",
      departmentName: "",
      teachersList: [],
      loading: false,
      syncing: false,
    };
  },
  mounted() {
    this.departmentId = this.$route.query.departmentId;
    this.departmentName = this.$route.query.name || "Kafedra";
    if (this.departmentId) {
      this.fetchTeachers();
    }
  },
  methods: {
    async fetchTeachers() {
      this.loading = true;
      try {
        const res = await axios.get(`${API}/employees`, {
          params: { _department: this.departmentId, type: 'teacher', _employee_status: '11', limit: 200 }
        });
        if (res.data.success) {
          let items = res.data.data.items || res.data.data || [];
          // Faqat faol ('Ishlamoqda') o'qituvchilarni filtrlash, bo'shaganlarni chiqarib tashlash
          items = items.filter(t => {
            if (!t) return false;
            const code = String(t.employeeStatus?.code || '').trim();
            const name = (t.employeeStatus?.name || '').toLowerCase().trim();
            if (code === '14' || name.includes('bo‘sha') || name.includes('bo\'sha') || name.includes('boshagan')) {
              return false;
            }
            return code === '11' || name.includes('faol') || name.includes('active') || name.includes('ishla');
          });
          this.teachersList = items;
        }
      } catch (err) {
        console.error("Xatolik:", err);
      } finally {
        this.loading = false;
      }
    },
    async syncEmployees() {
      this.syncing = true;
      try {
        const token = localStorage.getItem("token");
        const res = await axios.post(`${API}/employees/sync`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.success) {
          alert(res.data.message || "Xodimlar muvaffaqiyatli yangilandi!");
          await this.fetchTeachers();
        } else {
          alert(res.data.error || "Yangilashda xatolik yuz berdi");
        }
      } catch (err) {
        console.error("Sync error:", err);
        alert("Xodimlarni yangilashda xatolik yuz berdi: " + (err.response?.data?.error || err.message));
      } finally {
        this.syncing = false;
      }
    },
    getTeacherImage(teacher) {
      if (!teacher || teacher.imgFailed) return null;
      const rawUrl = teacher.image || teacher.image_full || teacher.picture || teacher.meta?.image;
      if (!rawUrl || typeof rawUrl !== 'string' || !rawUrl.trim()) return null;
      if (rawUrl.includes('hemis.tdmau.uz') || rawUrl.startsWith('http')) {
        return `${API}/image-proxy?url=${encodeURIComponent(rawUrl)}`;
      }
      return rawUrl;
    },
    handleImgError(event, teacher) {
      if (teacher) {
        teacher.imgFailed = true;
      }
      if (event && event.target) {
        event.target.style.display = 'none';
        if (event.target.parentElement) {
          event.target.parentElement.style.display = 'none';
        }
      }
    },
    getInitials(teacher) {
      const name = teacher.full_name || teacher.short_name || "";
      const parts = name.split(" ");
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    },
    getPositionClass(teacher) {
      if (!teacher.staffPosition) return '';
      const name = teacher.staffPosition.name.toLowerCase();
      if (name.includes('professor')) return 'pos-professor';
      if (name.includes('dotsent')) return 'pos-dotsent';
      if (name.includes('mudiri') || name.includes('kafedra')) return 'pos-mudiri';
      if (name.includes('katta')) return 'pos-katta';
      if (name.includes('assistent')) return 'pos-assistent';
      if (name.includes('stajer') || name.includes('stajyor')) return 'pos-stajer';
      return 'pos-default';
    },
    goToScientificActivity(teacher) {
      const img = this.getTeacherImage(teacher) || '';
      this.$router.push({
        path: "/tanlov-fanlar/oqituvchilar/ishi",
        query: {
          employee_id: teacher.id,
          name: teacher.short_name || teacher.full_name,
          image: img,
          position: teacher.staffPosition ? teacher.staffPosition.name : '',
          department: this.departmentName,
          degree: teacher.academicDegree ? teacher.academicDegree.name : '',
          rank: teacher.academicRank ? teacher.academicRank.name : ''
        }
      });
    }
  }
};
</script>

<style scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f2f5 0%, #e8ecf1 100%);
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

.page-container {
  flex: 1;
  padding: 28px 36px;
  width: 100%;
}

/* Breadcrumb & Actions */
.page-header {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.btn-sync {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  background: linear-gradient(135deg, #4f46e5 0%, #3b82f6 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.25);
  transition: all 0.2s ease;
}

.btn-sync:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(79, 70, 229, 0.35);
  background: linear-gradient(135deg, #4338ca 0%, #2563eb 100%);
}

.btn-sync:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.spinner-sm {
  width: 16px;
  height: 16px;
  animation: spin 0.8s linear infinite;
}

.breadcrumb {
  font-size: 15px;
  font-weight: 500;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 6px;
}

.crumb-link {
  color: #7c8db0;
  cursor: pointer;
  transition: color 0.2s;
  display: flex;
  align-items: center;
  gap: 4px;
}

.crumb-link:hover {
  color: #4361ee;
}

.separator {
  color: #c5cdd8;
  display: flex;
  align-items: center;
}

.crumb-current {
  color: #374151;
  font-weight: 600;
}

/* Stats Bar */
.stats-bar {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 24px;
}

.stat-card {
  background: white;
  border-radius: 14px;
  padding: 22px 26px;
  display: flex;
  align-items: center;
  gap: 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.06);
  transition: transform 0.2s, box-shadow 0.2s;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.stat-icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.teachers-icon {
  background: linear-gradient(135deg, #ede9fe, #ddd6fe);
  color: #7c3aed;
}

.dept-icon {
  background: linear-gradient(135deg, #dbeafe, #bfdbfe);
  color: #2563eb;
}

.status-icon {
  background: linear-gradient(135deg, #d1fae5, #a7f3d0);
  color: #059669;
}

.stat-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}

.dept-name-stat {
  font-size: 15px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stat-label {
  font-size: 13px;
  color: #94a3b8;
  font-weight: 500;
}

/* Table Card */
.table-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.06);
  overflow-x: auto;
}

/* Loading */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 16px;
}

.spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e2e8f0;
  border-top-color: #7c3aed;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loading-text {
  font-size: 14px;
  color: #94a3b8;
  font-weight: 500;
}

/* Empty */
.empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 12px;
}

.empty-container p {
  font-size: 14px;
  color: #94a3b8;
  font-weight: 500;
}

/* Table */
.main-table {
  width: 100%;
  border-collapse: collapse;
}

.main-table th {
  text-align: left;
  padding: 16px 20px;
  font-size: 13px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #f1f5f9;
  background: #fafbfc;
}

.col-num { width: 60px; text-align: center; }
.col-img { width: 90px; }
.col-name { min-width: 240px; }
.col-position { min-width: 180px; }
.col-degree { min-width: 180px; }
.col-rank { min-width: 140px; }

/* Data Rows */
.data-row {
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.15s ease;
}

.data-row:last-child {
  border-bottom: none;
}

.data-row:hover {
  background: linear-gradient(90deg, #faf5ff 0%, #f8fafc 100%);
}

.data-row td {
  padding: 16px 20px;
  font-size: 14px;
  vertical-align: middle;
}

.cell-num {
  text-align: center;
  font-weight: 600;
  color: #94a3b8;
  font-size: 14px;
}

/* Avatar */
.cell-img {
  text-align: center;
}

.avatar-wrapper {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid #e2e8f0;
  transition: border-color 0.2s;
}

.data-row:hover .avatar-wrapper {
  border-color: #c4b5fd;
}

.teacher-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background: linear-gradient(135deg, #8b5cf6, #6d28d9);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.img-error {
  background: linear-gradient(135deg, #8b5cf6, #6d28d9);
}

/* Name */
.cell-name {
  font-weight: 600;
  color: #1e293b;
  font-size: 14px;
}

/* Position Badge */
.position-badge {
  display: inline-block;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.pos-professor {
  background: #fef3c7;
  color: #92400e;
}

.pos-dotsent {
  background: #dbeafe;
  color: #1e40af;
}

.pos-mudiri {
  background: #fce7f3;
  color: #9d174d;
}

.pos-katta {
  background: #d1fae5;
  color: #065f46;
}

.pos-assistent {
  background: #e0e7ff;
  color: #3730a3;
}

.pos-stajer {
  background: #ede9fe;
  color: #5b21b6;
}

.pos-default {
  background: #f1f5f9;
  color: #475569;
}

/* Degree */
.degree-text {
  color: #475569;
  font-size: 14px;
}

/* Rank badge */
.rank-badge {
  display: inline-block;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  background: #ecfdf5;
  color: #065f46;
}

/* No data */
.no-data {
  color: #cbd5e1;
  font-size: 13px;
  font-style: italic;
}

/* Bottom Bar */
.bottom-bar {
  background: white;
  padding: 14px 28px;
  border-top: 1px solid #e2e8f0;
  font-size: 12px;
  color: #94a3b8;
  text-align: center;
}
</style>
